import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Robot.es.js";
const t = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(a, { ref: r, ...e, weights: m }));
t.displayName = "RobotIcon";
const n = t;
export {
  n as Robot,
  t as RobotIcon
};
